import request from "@/utils/request";

export function callbackLogin(data) {
  return request({
    url: "extra/system/wecomauth/callbacklogin",
    method: "post",
    data
  });
}
